import { AccountDetails } from "../../components/wallet/AddPayoutAccount";
import { API_URLs } from "../../constants/api_urls"
import { apiConfigs } from "../../constants/apiConfigs";
import { PANDetails } from "../../types/influencer/influencerTypes";
import { WalletData } from "../../types/wallet/WalletTypes";
import axiosClient from "../../utils/axiosClient"

export const fetchWallet = async () : Promise<WalletData> => {
    const response = await axiosClient.get(apiConfigs.FETCH_WALLET.url);
    return response.data;
}

export const validateIFSC = async (code: string) : Promise<any> => {
    const response = await axiosClient.post(API_URLs.VALIDATE_IFSC, {code});
    return response.data;
}

export const saveBankDetails = async (accountDetails: AccountDetails) : Promise<any> => {
    const response = await axiosClient.post(API_URLs.SAVE_BANK_DETAILS, accountDetails);
    return response.data;
}

export const processPayout = async (amount: number) : Promise<any> => {
    const response = await axiosClient.post(API_URLs.PAYOUT, {amount});
    return response.data;
}

export const fetchPANDetails = async () : Promise<PANDetails> => {
    const response = await axiosClient.get(apiConfigs.FETCH_PAN_DETAILS.url);
    return response.data.pan;
}

export const validatePAN = async (pan: string) : Promise<{status: boolean, pan: PANDetails}> => {
    const response = await axiosClient.post(apiConfigs.VALIDATE_PAN.url, {pan});
    return response.data;
}

export const storePAN = async (validation_id: any) : Promise<any> => {
    const response = await axiosClient.post(apiConfigs.STORE_PAN.url, {validation_id});
    return response.data;
}